<template>
  <div class="mob-menu on" v-show="mobMenuVisible && winW < 1024">
      <div class="mob-menu-header">
        <a class="link" :href="logoutURL" rel="nofollow">
          <div class="img"> <svg style="transform: rotate(180deg)" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg"><g fill="none" fill-rule="evenodd"><path d="M0 0h30v30H0z"/><path d="M15.064 9.614a1 1 0 0 0 .229 1.093L18.586 14H8a1 1 0 1 0 0 2h10.586l-3.293 3.293a1 1 0 1 0 1.414 1.414l4.912-4.912a1 1 0 0 0-.002-1.592l-4.91-4.91a1 1 0 0 0-1.643.321z" fill="#FFF" fill-rule="nonzero"/></g></svg>
</div>
        {{ $t("pop_ups.left_menu.logout") }}
        </a>
        <ul class="mob-menu-lang">
          <select id="mob-header-lang" ref="mob_header_lang" @change="changeLang()">
            <option value="ru" :selected="$i18n.locale === 'ru'">RU</option>
            <option value="ua" :selected="$i18n.locale === 'ua'">UA</option>
          </select>
        </ul>
      </div>
      <div class="mob-menu-content">
        <svg width="210" height="105" xmlns:xlink="http://www.w3.org/1999/xlink">
          <defs>
            <path id="a" d="M0 .09h209.987v104.74H0z"></path>
          </defs>
          <g fill="none" fill-rule="evenodd">
            <g>
              <mask id="b" fill="#fff">
                <use xlink:href="#a"></use>
              </mask>
              <path d="M209.987.09C154.95 23.598 55.037 23.598 0 .09l17.499 87.28c44.632 23.233 126.984 23.325 174.989 0L209.987.09z" fill="red" mask="url(#b)"></path>
            </g>
            <path fill="#FFF" d="M49.285 40l-3.342 19.17-.225 1.288h-.436l-.223-1.278L41.715 40 35 40.005V75h5.192l.021-10.34-.445-11.697h.418L44.131 75h2.738l3.945-22.037h.418l-.445 11.696V75H56V40.005zM70.26 40l-.143 28.877c0 1.517-1.41 1.868-2.117 1.868-.796 0-2.117-.351-2.117-1.868L65.74 40H60l.475 27.557C60.475 72.42 62.268 75 68 75s7.525-2.581 7.525-7.443L76 40h-5.74zM85.228 70.636V40H80v35h11v-4.364zM138.362 70.636V40H133v35h11v-4.364zM157 44.364V40h-11v35h10.925v-4.364h-5.655V57.58h4.216v-4.364h-4.216v-8.852zM104 40H89v4.21h4.741V75h5.518V44.21H104zM107 75h5V40h-5zM125.287 53.821c0 1.363-.301 2.613-2.578 2.613h-.996V44.362h1.407c2.44 0 2.167 1.565 2.167 2.928v6.531zm-1.623-13.818L116 40v35h5.713V60.83h2.14c4.803 0 7.147-2.412 7.147-6.17v-8.13c0-3.758-1.733-6.527-7.336-6.527zM174.646 40h-5.56l-2.37 13.027h-.432L163.914 40h-5.56l3.51 15.071L158 75h5.764l2.013-12.028.51-5.735h.422l.515 5.735L169.199 75H175l-3.863-19.929z"></path>
          </g>
        </svg>
  
        <div class="mob-menu-list">
          <p>
            <a href="https://multiplex.ua" class="menu_item ">
              {{ $t("pop_ups.left_menu.now_in_cinema") }}</a>
          </p>
          <p>
            <a href="https://multiplex.ua/soon" class="menu_item">
              {{ $t("pop_ups.left_menu.soon") }}</a>
          </p>
          <p>
            <a href="https://multiplex.ua/promotions" class="menu_item">
              {{ $t("pop_ups.left_menu.promos") }}</a>
          </p>
          <p>
            <a href="https://multiplex.ua/cinemas" class="menu_item">
              {{ $t("pop_ups.left_menu.cinemas") }}</a>
          </p>
          <p>
            <a href="https://multiplex.ua/faq" class="menu_item">
              {{ $t("pop_ups.left_menu.faq") }}</a>
          </p>
          <p>
            <a href="https://multiplex.ua/about" class="menu_item">
              {{ $t("pop_ups.left_menu.about") }}</a>
          </p>
          <p>
            <a href="/" class="menu_item active">
              {{ $t("pop_ups.left_menu.personal") }}</a>
          </p>
          <p class="mob-menu-phone"><a href="tel:0800505333">
				  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><g fill="none" fill-rule="evenodd" opacity=".5"><path d="M0 0h24v24H0z"/><path d="M11 2C8.803 2 7 3.803 7 6s1.803 4 4 4 4-1.803 4-4-1.803-4-4-4zm0 2c1.116 0 2 .884 2 2s-.884 2-2 2-2-.884-2-2 .884-2 2-2zm0 9c-3.141 0-9 1.546-9 4.5V20h9.277c.152-.684.36-1.354.633-2H4v-.5c0-.869 3.708-2.5 7-2.5.838 0 1.701.105 2.525.277.26-.326.532-.641.827-.94.254-.25.521-.489.796-.714C13.683 13.21 12.157 13 11 13zm11.443 0a9.544 9.544 0 0 0-6.685 2.76A9.542 9.542 0 0 0 13 22.443c0 .374.313.557.557.557h1.949c.302 0 .55-.24.556-.543.008-.35.03-.79.079-1.068.053-.301.157-.663.236-.918a.566.566 0 0 0-.143-.567l-.664-.72C15.571 19.184 16 18 17 17c1-1 2.232-1.479 2.232-1.479l.672.715a.565.565 0 0 0 .567.141c.254-.079.617-.183.918-.236.278-.05.718-.07 1.068-.078a.557.557 0 0 0 .543-.557v-1.95a.552.552 0 0 0-.557-.556z" fill="#FFF" fill-rule="nonzero"/></g></svg>
				0 800 505 333</a></p>
        </div>
        <div class="mob-menu-app">
			<div class="left">
				<div class="text">
					{{ $t("pop_ups.left_menu.bottom") }}
				</div>
				<a v-show="iOS" href="https://itunes.apple.com/ua/app/multiplex-cinema/id1160648734?l=ru&mt=8" id="app_link_ios" target="_blank"><img src="../../assets/img/appstore-m.svg" alt=""></a>
				<a v-show="android" href="https://play.google.com/store/apps/details?id=com.interpretator.multiplex" id="app_link_android" target="_blank" style="display: none"><img src="../../assets/img/gplay.svg" alt=""></a>
			</div>
			<div class="right">
				<img v-show="iOS" id="app_img_ios" src="../../assets/img/iphone-white.png" alt="">
				<img v-show="android" id="app_img_android" src="../../assets/img/android-white.png" alt="" style="display: none">
			</div>
		</div>
      </div>
    </div>
</template>
<script>
import Store from '../../store'
export default {
  computed: {
    winW: function () {
      return Store.state.winW
    },
    iOS: function () {
      return /iPhone|iPod/.test(navigator.userAgent) && !window.MSStream
    },
    android: function () {
      return navigator.userAgent.toLowerCase().indexOf('android') > -1
    },
    mobMenuVisible: function () {
      return Store.state.mobMenuVisible
    },
    logoutURL: function () {
      return Store.state.logoutURL
    }
  },
  methods: {
    setLang: function (lang) {
      Store.commit('setLang', lang)
      this.$i18n.locale = lang
      this.$cookie.set('uLang', lang, {expires: 365, domain: '.multiplex.ua'})
      this.hideMobMenu()
      document.title = this.$t('commons.title')
    },
    changeLang: function () {
      this.setLang(this.$refs.mob_header_lang.value)
    },
    hideMobMenu: function () {
      Store.commit('hideMobMenu')
    }
  }
}
</script>



// WEBPACK FOOTER //
// mob-menu.vue?3c77db00